"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var linkingConfig_exports = {};
__export(linkingConfig_exports, {
  ensureBaseLinkingConfig: () => ensureBaseLinkingConfig,
  getResolvedLinking: () => getResolvedLinking,
  getSSRInitialState: () => getSSRInitialState,
  resetLinking: () => resetLinking,
  setLinking: () => setLinking,
  setupLinking: () => setupLinking
});
module.exports = __toCommonJS(linkingConfig_exports);
var import_constants = require("../constants");
var import_evictOldest = require("../utils/evictOldest");
var import_getLinkingConfig = require("./getLinkingConfig");
var linkingConfig;
var cachedBaseLinkingConfig;
var cachedRouteNodeForLinking = null;
var cachedLinkingConfigKey = "";
var ssrStateCache = /* @__PURE__ */ new Map();
function getResolvedLinking() {
  return linkingConfig;
}
function setLinking(_) {
  linkingConfig = _;
}
function resetLinking() {
  linkingConfig = void 0;
}
function ensureBaseLinkingConfig(routeNode, linking) {
  var linkingConfigKey = getLinkingConfigKey(linking);
  if (routeNode && (routeNode !== cachedRouteNodeForLinking || linkingConfigKey !== cachedLinkingConfigKey || !cachedBaseLinkingConfig)) {
    (0, import_getLinkingConfig.clearStateCache)();
    ssrStateCache.clear();
    cachedBaseLinkingConfig = (0, import_getLinkingConfig.getLinkingConfig)(routeNode, true, linking);
    cachedRouteNodeForLinking = routeNode;
    cachedLinkingConfigKey = linkingConfigKey;
  }
}
function getSSRInitialState(routeNode, initialLocation, linking) {
  var _cachedBaseLinkingConfig_getStateFromPath;
  if (!routeNode) return void 0;
  ensureBaseLinkingConfig(routeNode, linking);
  if (!cachedBaseLinkingConfig) return void 0;
  var path = initialLocation.pathname + (initialLocation.search || "");
  if (ssrStateCache.has(path)) return ssrStateCache.get(path);
  var state = (_cachedBaseLinkingConfig_getStateFromPath = cachedBaseLinkingConfig.getStateFromPath) === null || _cachedBaseLinkingConfig_getStateFromPath === void 0 ? void 0 : _cachedBaseLinkingConfig_getStateFromPath.call(cachedBaseLinkingConfig, path, cachedBaseLinkingConfig.config);
  (0, import_evictOldest.evictOldest)(ssrStateCache, 5e3, 1e3);
  ssrStateCache.set(path, state);
  return state;
}
function setupLinking(routeNode, initialLocation, linking) {
  var initialState;
  if (routeNode) {
    ensureBaseLinkingConfig(routeNode, linking);
    linkingConfig = {
      ...cachedBaseLinkingConfig
    };
    if (initialLocation) {
      var _linkingConfig_getStateFromPath;
      linkingConfig.getInitialURL = function() {
        return initialLocation.toString();
      };
      var path = initialLocation.pathname + (initialLocation.search || "");
      if (import_constants.isWebClient) {
        var _historyState___tempLocation;
        var historyState = window.history.state;
        if ((historyState === null || historyState === void 0 ? void 0 : (_historyState___tempLocation = historyState.__tempLocation) === null || _historyState___tempLocation === void 0 ? void 0 : _historyState___tempLocation.pathname) && !historyState.__tempKey) {
          path = historyState.__tempLocation.pathname + (historyState.__tempLocation.search || "");
        }
      }
      initialState = (_linkingConfig_getStateFromPath = linkingConfig.getStateFromPath) === null || _linkingConfig_getStateFromPath === void 0 ? void 0 : _linkingConfig_getStateFromPath.call(linkingConfig, path, linkingConfig.config);
    }
  }
  return initialState;
}
var filterIds = /* @__PURE__ */ new WeakMap();
var filterIdCounter = 0;
function getFilterId(filter) {
  if (!filter) return 0;
  var id = filterIds.get(filter);
  if (id === void 0) {
    id = ++filterIdCounter;
    filterIds.set(filter, id);
  }
  return id;
}
function getLinkingConfigKey(linking) {
  var _ref;
  var schemes = Array.isArray(linking === null || linking === void 0 ? void 0 : linking.scheme) ? [
    ...linking.scheme
  ].sort() : (_ref = linking === null || linking === void 0 ? void 0 : linking.scheme) !== null && _ref !== void 0 ? _ref : null;
  var prefixes = (linking === null || linking === void 0 ? void 0 : linking.prefixes) ? [
    ...linking.prefixes
  ].sort() : null;
  return JSON.stringify({
    scheme: schemes,
    prefixes,
    filterId: getFilterId(linking === null || linking === void 0 ? void 0 : linking.filter)
  });
}
//# sourceMappingURL=linkingConfig.js.map
